import { configureStore } from '@reduxjs/toolkit';
import context from '../slices/context-slice';
import ui from '../slices/ui-slice';
import messages from '../slices/messages-slice';
import conversations from '../slices/conversations-slice';
import brandDiscovery from '../slices/brand-discovery-slice';

const store = configureStore({
  devTools: { name: "Chat" },
  reducer: {
    context,
    ui,
    messages,
    conversations,
    brandDiscovery,
  },
});

export default store;
